import { render } from "./pageContainer.vue?vue&type=template&id=4669f1c6&scoped=true&lang=pug"
import script from "./pageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./pageContainer.vue?vue&type=script&setup=true&lang=js"

import "./pageContainer.vue?vue&type=style&index=0&id=4669f1c6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4669f1c6"]])

export default __exports__